import { writable } from 'svelte/store';
import type { UserSession, InspectionRecord } from './types';

export const session = writable<UserSession | null>(null);
export const currentStep = writable<'selection' | 'checklist' | 'summary'>('selection');
export const records = writable<Record<string, InspectionRecord>>({});
export const selectedChecklistId = writable<string | null>(null);
// 字型大小設定：'small' | 'medium' | 'large'，預設為 large
export const fontSize = writable<'small' | 'medium' | 'large'>('large');
